//utils.js
export function clamp(v, min, max) {
  return Math.max(min, Math.min(max, v));
}

export function lerp(a, b, t) {
  return a + (b - a) * t;
}

export function lerpExp(current, target, speed, dt) {
  const t = 1 - Math.exp(-speed * dt);
  return lerp(current, target, t);
}

// 화면좌표 -> 월드좌표
export function screenToWorld(sx, sy, camera, viewport) {
  const { width, height } = viewport;
  const cx = sx - width / 2;
  const cy = sy - height / 2;
  return {
    x: cx / camera.scale + camera.x,
    y: cy / camera.scale + camera.y,
  };
}

export function screenToWorldOut(out, sx, sy, camera, viewport) {
  const { width, height } = viewport;
  const cx = sx - width / 2;
  const cy = sy - height / 2;
  out.x = cx / camera.scale + camera.x;
  out.y = cy / camera.scale + camera.y;
  return out;
}

// 월드좌표 -> 화면좌표
export function worldToScreen(wx, wy, camera, viewport) {
  const { width, height } = viewport;
  return {
    x: (wx - camera.x) * camera.scale + width / 2,
    y: (wy - camera.y) * camera.scale + height / 2,
  };
}

export function dist(ax, ay, bx, by) {
  const dx = ax - bx;
  const dy = ay - by;
  return Math.hypot(dx, dy);
}

// 두 점 객체 거리
export function distPt(a, b) {
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  return Math.hypot(dx, dy);
}

// 두 점 중점
export function midPt(a, b) {
  return {
    x: (a.x + b.x) / 2,
    y: (a.y + b.y) / 2,
  };
}

export function getItemCenter(item) {
  if (!item) return { x: 0, y: 0 };

  if (item.type === 'point') {
    return {
      x: item.cx ?? item.x,
      y: item.cy ?? item.y,
    };
  }

  return {
    x: item.x ?? 0,
    y: item.y ?? 0,
  };
}

export function formatTime(sec = 0) {
  if (!Number.isFinite(sec) || sec < 0) sec = 0;
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

const Utils = {
  clamp,
  lerp,
  lerpExp,
  screenToWorld,
  screenToWorldOut,
  worldToScreen,
  dist,
  distPt,
  midPt,
  getItemCenter,
  formatTime,
};

export default Utils;
